// --------------------------------------------------------------------------
// Wild Challenge Proof Module - Show/hide depending on stage in the journey
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
	var ref = { $root: options.context };
	var state = { proofUploaded: false };
	var inactive = 'inactive';

	function render() {
		/// Update the UI
		ref.$textarea.toggleClass(inactive, !state.proofUploaded);
		ref.$permission.toggleClass(inactive, !state.proofUploaded);
		ref.$proofLater.toggleClass(inactive, state.proofUploaded);
	}

	function init() {
		/// Cache DOM elements
		ref.$uploadInput = ref.$root.find('[data-binding="file-upload-input"]');
		ref.$textarea = ref.$root.find('[data-name="wild-challenge-textarea"]');
		ref.$permission = ref.$root.find('[data-name="wild-challenge-permission"]');
		ref.$proofLater = ref.$root.find('[data-name="wild-challenge-proof-later"]');

		/// Bind events
		ref.$root.on('change', '[data-binding="file-upload-input"]', function () {
			/// Check to see if a file has been uploaded
			state.proofUploaded = !!ref.$uploadInput.length && ref.$uploadInput.val() !== 'null';
			/// Trigger render
			render();
		});

		ref.$root.on('click', '[data-binding="file-upload-remove-file"]', function () {
			/// If a file has been removed, update the state
			state.proofUploaded = false;
			/// Trigger render
			render();
		});

		render();
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/wild-challenge/wild-challenge-proof-module.js
// module id = 480
// module chunks = 0